module.exports = __webpack_public_path__ + "img/pin-map.6dfc1d04.svg";